import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

// Import Swiper styles
import { IonIcon } from '@ionic/react';
import classNames from 'classnames';
import { ellipse } from 'ionicons/icons'; // Import the specific icon you want to use
import { A11y, Navigation } from 'swiper';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import styles from './select-image-slider.module.css';

/* eslint-disable-next-line */
export interface SelectImageSliderProps {
  options: {
    valueLabel: string;
    data_collection: string;
    src: string;
    value: string;
  }[];
  onChange: (index: string) => void;
  value?: string;
}

export function SelectImageSlider(props: SelectImageSliderProps) {
  return (
    <div className={styles['container']}>
      <button
        className={`swiper-button-prev ${styles['swiper-button']} ${styles['swiper-button--prev']}`}
      ></button>
      <Swiper
        key={props.options.length}
        a11y={{
          slideRole: 'option',
        }}
        className={styles['swiper-container']}
        initialSlide={props.options.length - 1}
        modules={[Navigation, A11y]}
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
          lockClass: 'lock',
        }}
        role="listbox"
        slidesPerView={'auto'}
        spaceBetween={0}
      >
        {props.options.map((option) => (
          <SwiperSlide
            key={option.value}
            aria-label={option.valueLabel}
            aria-labelledby={`image-${option.valueLabel.replace(' ', '-')}`}
            aria-selected={option.valueLabel === props.value}
            className={classNames(styles['slides'], {
              [styles['slides--active']]: option.value === props.value,
            })}
            onClick={() => props.onChange(option.value)}
          >
            <span id={`image-${option.value.replace(' ', '-')}`}>
              {option.valueLabel}
            </span>
            <div style={{ position: 'relative' }}>
              <img
                alt={`day ${option.valueLabel}`}
                // we need to set crossOrigin to anonymous to avoid opaque responses in sw cache
                crossOrigin="anonymous"
                src={option.src}
              />
            <div style={{
                position: 'absolute',
                top: '0px',    // Adjust this value as needed
                right: '0px',  // Adjust this value as needed
              }}>
                <IonIcon icon={ellipse} style={{ color: option.data_collection === 'S2' ? 'red' : 'blue' }} />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <button
        className={`swiper-button-next ${styles['swiper-button']} ${styles['swiper-button--next']}`}
      ></button>
    </div>
  );
}

export default SelectImageSlider;
